const psychology = [
  {
    headline:
      "People on two sides of an issue can listen to the same story, and each will walk away with a different interpretation.",
    media: "https://fs.blog/wp-content/uploads/2017/05/Confirmation-Bias.png",
    article: "https://www.verywellmind.com/what-is-a-confirmation-bias-2795024",
  },
  {
    headline: "We support opinions as they become more popular.",
    media:
      "https://thedecisionlab.b-cdn.net/wp-content/uploads/2019/08/Untitled_Artwork-1.jpg",
    article:
      "https://www.psychologytoday.com/us/blog/stronger-the-broken-places/201708/the-bandwagon-effect",
  },
  {
    headline:
      "We are often more motivated by rewards of unknown magnitudes than by known rewards because the uncertainty makes it feel like a game.",
    media:
      "https://assets.website-files.com/5da817383e548853bed9550a/5e67c7df8c296f5add3bfba0_5957b2c32149c6201bb5eac8_Motivating-Uncertainty%2520Effect%2520Water.png",
    article:
      "https://tactics.convertize.com/definitions/motivating-uncertainty-effect",
  },
  {
    headline:
      "Once we have made our choice, we stick with it. We defend our Brand decision with all we've got.",
    media: "https://cxl.com/wp-content/uploads/2015/12/Post-Purchase-1.jpg",
    article:
      "https://dollarsandsense.sg/how-to-avoid-stockholm-syndrome-when-you-buy/",
  },
  {
    headline:
      "When multiple similar objects are present, the one that differs from the rest is most likely to be remembered.",
    media:
      "https://exploringyourmind.com/wp-content/uploads/2019/02/balloons-von-restroff-effect.jpg",
    article: "https://practicalpie.com/von-restorff-effect/",
  },
  {
    headline:
      "People want what they can’t have, or what they think they can have but others cannot.",
    media:
      "https://i0.wp.com/www.paulbrook.co.uk/wp-content/uploads/The-Scarcity-Principle-Is-Making-You-Buy-More-Brook-Mind-Play.jpg",
    article: "https://www.referralcandy.com/blog/scarcity-marketing-examples/",
  },
  {
    headline:
      "Information bias is the delusion that more information guarantees better decisions.",
    media:
      "https://3kllhk1ibq34qk6sp3bhtox1-wpengine.netdna-ssl.com/wp-content/uploads/2019/07/bias_-_availability.png",
    article: "https://fs.blog/2013/10/more-information-decisions/",
  },
  {
    headline: "People exert less effort when they work in a group.",
    media: "https://pbs.twimg.com/media/Ee1oXfRWsAAw-1r.jpg",
    article: "https://theinvestorsbook.com/social-loafing.html",
  },
  {
    headline:
      "Groupthink works where a group of smart people makes reckless decisions because everyone aligns their opinions with the supposed consensus.",
    media: "https://insurercio.com/images/ges.png",
    article: "https://www.mindtools.com/pages/article/newLDR_82.htm",
  },
  {
    headline: "We consider things to be more valuable the moment we own them.",
    media:
      "https://i1.wp.com/kenthendricks.com/wp-content/uploads/2018/11/endowment-effect.png?fit=1200%2C630&ssl=1",
    article:
      "https://blog.crobox.com/article/endowment-effect-marketing-examples",
  },
  {
    headline:
      "We believe that we can influence something over which we have absolutely no sway.",
    media:
      "https://i1.wp.com/redeeminggod.com/wp-content/uploads/2015/02/Illusion-of-Control.gif?resize=600%2C192&ssl=1",
    article: "https://thedecisionlab.com/biases/illusion-of-control/",
  },
  {
    headline:
      "One is Planck knowledge, the people who really know. And then we've got chauffeur knowledge. They've learned the talk.",
    media:
      "https://1.bp.blogspot.com/-yzkQ5sAUzG8/XoSXoSGMSBI/AAAAAAAAVGY/ea-FsoCBeGUsAlp8ds61cz-S0ybePVsSQCNcBGAsYHQ/s1600/Chauffeur%2Bnew1.jpg",
    article:
      "https://economictimes.indiatimes.com/wealth/invest/to-upgrade-from-chauffeur-knowledge-to-planck-knowledge-learn-from-others-investing-experience/articleshow/77032745.cms?from=mdr",
  },
  {
    headline:
      "Due to contrast effect the B's central gray square appears darker when both are of same color.",
    media:
      "https://www.researchgate.net/profile/SM_Lehar/publication/235764942/figure/fig7/AS:299878178672645@1448507937189/Simultaneous-Contrast-Effect-The-color-of-the-central-gray-square-appears-brighter.png",
    article: "https://effectiviology.com/contrast-effect/",
  },
  {
    headline:
      "If the lyrics of a song are ambiguous and you struggle to make them out, your brain will fill in the missing information as best as it can.",
    media:
      "https://cdn.psychologytoday.com/sites/default/files/styles/amp_metadata_content_image_min_1200px_wide/public/blogs/5088/2012/05/95434-91979.jpg?itok=7gaw07Dq",
    article:
      "https://www.verywellmind.com/priming-and-the-psychology-of-memory-4173092",
  },
  {
    headline:
      "People often avoid negative information, including feedback that could help them monitor their goal progress.",
    media: "https://miro.medium.com/max/16000/1*zSttG88z_KVYsKh8Cy03Gg.png",
    article: "https://effectiviology.com/ostrich-effect/",
  },
  {
    headline:
      "There are times when we feel compelled to act, even if there’s no evidence that it will lead to a better outcome than doing nothing would.",
    media:
      "https://www.joostverweij.nl/wp-content/uploads/ux-02febr-bias-actionbias-v1-262x300.jpg",
    article: "https://facilethings.com/blog/en/action-bias",
  },
  {
    headline:
      "We feel more inclined to give a store our business after hearing that it donates to charity or that its products are ethically sourced.",
    media:
      "https://uploads-ssl.webflow.com/589ead606063a93654e4927d/5957affac871424b36565e7a_42%20Noble%20Edge%20Effect%20Illustration%201.png",
    article: "https://thedecisionlab.com/biases/noble-edge-effect/",
  },
  {
    headline:
      "The pain of losing is psychologically twice as powerful as the pleasure of gaining.",
    media:
      "https://i0.wp.com/kenthendricks.com/wp-content/uploads/2018/09/losses-loom-larger-than-gains.png?fit=940%2C788&ssl=1",
    article:
      "https://www.invespcro.com/blog/13-loss-aversion-marketing-strategies-to-increase-conversions/",
  },
  {
    headline:
      "When we acquire a new skill, we tend to see opportunities to use it everywhere.",
    media: "https://pbs.twimg.com/media/EVP8y6TU8AALImP.jpg",
    article: "https://thedecisionlab.com/biases/law-of-the-instrument/",
  },
  {
    headline: "Your preference for justice makes you presume it exists.",
    media:
      "https://www.easynotecards.com/uploads/398/86/1a51bb9a_136fa6f7989__8000_00000016.jpg",
    article:
      "https://www.verywellmind.com/what-is-the-just-world-phenomenon-2795304",
  },
  {
    headline:
      "People tend to give preferential treatment to others who belong to the same group that they do.",
    media: "https://i.imgur.com/IwCXBXY.jpg",
    article:
      "https://blogs.scientificamerican.com/beautiful-minds/in-group-favoritism-is-difficult-to-change-even-when-the-social-groups-are-meaningless/",
  },
  {
    headline:
      "IKEA Effect is the tendency to value an object more if people make (or assemble) it themselves.",
    media:
      "https://thebehavioursagency.com/wp-content/uploads/2018/07/Commitment_Personal-Investment-2.jpg",
    article:
      "https://www.bbc.com/worklife/article/20190422-how-the-ikea-effect-subtly-influences-how-you-spend",
  },
  {
    headline:
      "We are inclined to choose immediate rewards over rewards that come later in the future.",
    media: "https://miro.medium.com/max/6602/1*V5Z0IAyMPWyNU1gjs6Stug.png",
    article: "https://www.growthramp.io/articles/hyperbolic-discounting",
  },
  {
    headline:
      "When a random event occurs or is set to happen, we try to rationalize it by finding patterns or indications in the history of events similar to it.",
    media:
      "https://steamuserimages-a.akamaihd.net/ugc/608350301011756027/090E41DE0E7396BB560A9492DD8BE25A53064F86/",
    article: "https://www.beginnersbuck.com/gamblers-fallacy/",
  },
  {
    headline:
      "Digital amnesia is the tendency to forget information that is readily available through search engines like Google.",
    media: "https://web.colby.edu/cogblog/files/2019/11/google.png",
    article:
      "https://www.bbc.com/news/education-34454264#:~:text=It%20describes%20the%20rise%20of,personal%20memories%20in%20digital%20form.",
  },
  {
    headline:
      "We are influenced by how the same fact or question is presented.",
    media:
      "https://thedecisionlab.com/wp-content/uploads/2019/11/Framing-effect-g.jpg",
    article: "https://boycewire.com/framing-effect-definition-and-examples/",
  },
  {
    headline:
      "Sometimes people believe that they are smarter and more capable than they really are.",
    media:
      "https://www.businesstimes.com.sg/sites/default/files/styles/large_popup/public/image/2019/05/18/BT_20190518_LLDKEP1_3784237_0.jpg?itok=ol6MYUvM",
    article:
      "https://www.forbes.com/sites/markmurphy/2017/01/24/the-dunning-kruger-effect-shows-why-some-people-think-theyre-great-even-when-their-work-is-terrible/?sh=3f197eb05d7c",
  },
  {
    headline:
      "The decoy effect is the phenomenon whereby consumers change their preference between two options when presented with a third option.",
    media:
      "https://vk.am/wp-content/uploads/2017/04/12745160-5178055-3-0-1484954401-1484954410-0-1486126135-0-1486130470-1486130481-650-38-1488295420-650-fa00c7077d-1491550737.jpg",
    article: "https://www.crowdspring.com/marketing-psychology/decoy-effect/",
  },
  {
    headline:
      "We tend to be more willing to pay when there is no physical money involved in a transaction.",
    media:
      "https://www.alchemetrics-uk.com/wp-content/uploads/2018/07/cashless-society.jpg",
    article: "https://thedecisionlab.com/biases/cashless-effect/",
  },
  {
    headline:
      "We tend to be overly influenced by the first piece of information that we hear.",
    media:
      "https://assets.website-files.com/5da817383e548853bed9550a/5e67c7b4a862b3f5bfc0c9c1_5b9a34e798da87f1292ec90b_Anchoring.png",
    article:
      "https://www.pon.harvard.edu/daily/negotiation-skills-daily/the-drawbacks-of-goals/",
  },
  {
    headline:
      "Negative emotions lead people to focus on the potential downsides of a decision rather than the possible benefits.",
    media:
      "https://www.wheelofpersuasion.com/wp-content/uploads/2013/08/Moods.jpg",
    article:
      "https://www.verywellmind.com/what-is-the-affect-heuristic-2795028",
  },
  {
    headline:
      "People remember information better when they perceive that information as humorous.",
    media:
      "https://image.slidesharecdn.com/theeffectofhumoroncognitivelearningprocess-131124192053-phpapp02/95/the-effect-of-humor-on-cognitive-learning-process-1-638.jpg?cb=1385321413",
    article: "https://effectiviology.com/humor-effect/",
  },
  {
    headline:
      "While most people tend to focus on their weakness and trying to improve on those areas, you could be better served if you focus on your strengths instead.",
    media:
      "https://static1.squarespace.com/static/58813afa893fc03639611b4d/5887bf5cbebafb4107b5fb13/5887bfeb6a49631903131352/1485380850022/Best+Chicago+Marketing+Tips+For+Small+Businesses.png?format=1500w",
    article:
      "https://www.forbes.com/sites/forbescoachescouncil/2020/02/06/why-leaders-should-focus-on-strengths-not-weaknesses/?sh=6555125d3d1a",
  },
  {
    headline: "You make most of your decisions unconsciously.",
    media:
      "https://www.researchgate.net/profile/W-R-Klemm/publication/46393932/figure/fig1/AS:203064452620288@1425425746359/The-concept-of-free-will-as-an-illusion-Subconscious-mind-is-said-to_Q640.jpg",
    article: "https://www.rochester.edu/news/show.php?id=3295",
  },
  {
    headline:
      "Whenever we are embarrassed in public or we do something stupid, we have a feeling that the whole world is watching us.",
    media:
      "https://i.pinimg.com/originals/5e/82/ac/5e82acdc87f5247c70ffa22ee80f5f40.jpg",
    article:
      "https://effectiviology.com/spotlight-effect-stop-being-self-conscious/",
  },
  {
    headline: "We have stronger memory for uncompleted tasks.",
    media: "https://pbs.twimg.com/media/EeDD1fSU8AA3M-2.jpg:large",
    article: "https://www.goodtherapy.org/blog/psychpedia/zeigarnik-effect",
  },
];

export default psychology;
